/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';
import Fade from 'react-awesome-reveal';
import NotFound from 'assets/images/NotFound.png';
import Button from 'elements/Button';

export default function ServiceDetail({ data }) {
  if (!data) {
    return (
      <section className="container mx-auto">
        <Fade bottom triggerOnce>
          <div className="flex flex-col w-full justify-center">
            <div className="flex w-full justify-center">
              <img src={NotFound} alt="Not Found" className="sm:w-3/4 xl:w-5/12 mt-5" />
            </div>
            <h1 className="text-theme-blue text-2xl text-center mt-5">
              Service Not Found
            </h1>
            <div className="flex justify-center">
              <Button
                href="/service"
                type="link"
                className="flex w-30 h-10 px-5 mt-5 bg-theme-blue text-white items-center rounded transform transition duration-500 hover:bg-gray-900"
              >
                Go Back
              </Button>
            </div>
          </div>
        </Fade>
      </section>
    );
  }

  return (
    <section className="container mx-auto">
      <Fade bottom>
        <Button
          type="link"
          href="/service"
          className="flex w-40 h-8 text-lg items-center ml-6 sm:ml-20 mt-8 font-light text-gray-400 hover:underline"
        >
          <svg
            className="w-5 h-5 text-gray-400 mr-1"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
          See All Services
        </Button>
      </Fade>

      <div className="flex flex-col mt-8 justify-center">
      <Fade bottom triggerOnce>
    <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-theme-blue text-center font-bold break-words leading-tight">
      {data.title}
    </h1>
  </Fade>

        <Fade bottom delay={300} triggerOnce>
          <div className="flex justify-center xl:mb-6 mt-10">
            <img src={data.imageUrl} alt={data.title} className="w-full max-w-3xl object-contain rounded-lg shadow-md" />
          </div>
        </Fade>

        <Fade bottom delay={500} triggerOnce>
  <div className="flex flex-col mt-16 mb-12 mx-8 sm:mx-16 xl:mx-28">
    {data.description
      .split('\n')
      .filter(Boolean) // remove empty lines
      .map((para) => (
        <p className="font-light text-xl leading-relaxed">
          {para}
        </p>
      ))}
  </div>
</Fade>
      </div>
    </section>
  );
}
